import { render, staticRenderFns } from "./gridLote.vue?vue&type=template&id=b78c1d7c"
import script from "./gridLote.ts?vue&type=script&lang=js&external"
export * from "./gridLote.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b78c1d7c')) {
      api.createRecord('b78c1d7c', component.options)
    } else {
      api.reload('b78c1d7c', component.options)
    }
    module.hot.accept("./gridLote.vue?vue&type=template&id=b78c1d7c", function () {
      api.rerender('b78c1d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/fichaTecnica/gridLote.vue"
export default component.exports